<template>
  <div>
    <v-dialog
      persistent
      v-model="show"
      width="90%"
      max-width="600"
      scrollable
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-tabs
            v-model="tabModel"
          >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              v-for="(tab, tabKey) in classifications"
              :key="tabKey"
              :href="`#tab-${tab.tabId}`"
            >
              <span v-if="tab.title">{{tab.title}}</span>
              <v-icon v-if="tab.icon">{{tab.icon}}</v-icon>
            </v-tab>
          </v-tabs>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-tabs-items
            v-model="tabModel"
          >
            <v-tab-item
              v-for="(tabItem, tabItemKey) in classifications"
              :key="tabItemKey"
              :value="`tab-${tabItem.tabId}`"
            >
              <v-row class="py-4">
                <v-col
                  cols="12"
                  md="6"
                  class="py-4"
                  v-for="(field, fieldKey) in tabItem.fields"
                  :key="fieldKey"
                >
                  <v-text-field
                    v-if="field.type === 'text'"
                    dense
                    hide-details
                    :label="field.label"
                    v-model="field.value"
                  ></v-text-field>
                  <v-textarea
                    v-if="field.type === 'textarea'"
                    dense
                    hide-details
                    :label="field.label"
                    v-model="field.value"
                  ></v-textarea>
                  <v-select
                    v-if="field.type === 'select'"
                    dense
                    hide-details
                    :label="field.label"
                    :items="field.items"
                    :item-text="field.itemText"
                    :item-value="field.itemValue"
                    :multiple="field.multiple"
                    v-model="field.value"
                  >
                    <template v-slot:selection="{ item, index }" v-if="field.multiple">
                      <span v-if="index === 0">{{ item.Status_Descr }}</span>
                      <span
                        v-if="index === 1"
                        class="grey--text text-caption pl-2"
                      >
                        (+{{ field.value.length - 1 }} others)
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="show = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="canSave"
            color="success"
            @click="onSave"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'MetricEditor',
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data () {
    return {
      tabModel: null,
      classifications: [
        {
          icon: 'mdi-plus-circle',
          tabId: 'create-classification',
          fields: [
            {
              type: 'text',
              label: 'Title',
              value: null
            },
            {
              type: 'select',
              label: 'Assign To',
              value: null,
              multiple: true,
              items: [],
              itemText: 'Status_Descr',
              itemValue: 'Status_ID'
            }
          ]
        }
      ]
    }
  },
  mounted () {
    this.getEmployeeStatuses()
    this.getMetricClassifications()
  },
  computed: {
    canSave () {
      let res = false
      for (let i = 0; i < this.currentClassificationFields.length; i++) {
        if (!this.currentClassificationFields[i].value || !this.currentClassificationFields[i].value.length) {
          res = false
          break
        } else {
          res = true
        }
      }
      return res
    },
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    currentTabID () {
      return this.classifications.filter(item => 'tab-' + item.tabId === this.tabModel)[0].tabId
    },
    currentClassificationFields () {
      const _classification = this.classifications.filter(item => 'tab-' + item.tabId === this.tabModel)[0]
      return _classification ? _classification.fields : []
    }
  },
  methods: {
    onSave () {
      if (this.currentTabID === 'create-classification') {
        this.createNewClassification()
      } else {
        this.createNewMetric()
      }
    },
    createNewMetric () {
      const body = {
        Title: this.currentClassificationFields.filter(item => item.label === 'Title')[0].value,
        Essensce: this.currentClassificationFields.filter(item => item.label === 'Essensce')[0].value,
        Calculation: this.currentClassificationFields.filter(item => item.label === 'Calculation')[0].value,
        Limit_Value: this.currentClassificationFields.filter(item => item.label === 'Limit Value')[0].value,
        Classification_ID: this.currentTabID
      }
      this.axios.post('/api/metrics/create_metric', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.show = false
        this.$store.dispatch('setSuccess', { successMsg: 'Metric successfully created' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    createNewClassification () {
      const newMetricData = {
        Classification_Title: this.classifications[this.classifications.length - 1].fields[0].value,
        Assigns: this.classifications[this.classifications.length - 1].fields[1].value
      }
      this.axios.post('/api/metrics/classifications', newMetricData, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.classifications.splice(this.classifications.length - 1, 0, {
          title: res.data[0].Classification_Title,
          tabId: res.data[0].Classification_ID,
          fields: [
            {
              type: 'text',
              label: 'Title',
              value: null
            },
            {
              type: 'textarea',
              label: 'Essensce',
              value: null
            },
            {
              type: 'textarea',
              label: 'Calculation',
              value: null
            },
            {
              type: 'textarea',
              label: 'Limit Value',
              value: null
            }
          ]
        })
        this.$store.dispatch('setSuccess', { successMsg: 'Classification successfully created' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getMetricClassifications () {
      this.axios.get('/api/metrics/classifications', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        res.data.reverse()
        for (let i = 0; i < res.data.length; i++) {
          if (!res.data[i].Enabled) continue
          const _classification = {
            title: res.data[i].Classification_Title,
            tabId: res.data[i].Classification_ID,
            fields: [
              {
                type: 'text',
                label: 'Title',
                value: null
              },
              {
                type: 'textarea',
                label: 'Essensce',
                value: null
              },
              {
                type: 'textarea',
                label: 'Calculation',
                value: null
              },
              {
                type: 'textarea',
                label: 'Limit Value',
                value: null
              }
            ]
          }
          this.classifications.unshift(_classification)
        }
        this.tabModel = 'tab-' + this.classifications[0].tabId
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getEmployeeStatuses () {
      this.axios.get('/api/metrics/employee_statuses', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.classifications[this.classifications.length - 1].fields[1].items = res.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>
